// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qingdan-zimu[data-v-fafbf2ee] .el-tabs__nav {
  background: #fff;
}
.qingdan-zimu .left[data-v-fafbf2ee],
.qingdan-zimu .right[data-v-fafbf2ee] {
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/BillPricingSoftware/ConstructionCostBudget/Qingdanzimu.vue","webpack://./Qingdanzimu.vue"],"names":[],"mappings":"AACA;EAEI,gBAAA;ACDJ;ADDA;;EAMI,YAAA;EACA,WAAA;ACDJ","sourcesContent":["\n.qingdan-zimu {\n  ::v-deep .el-tabs__nav {\n    background: #fff;\n  }\n  .left,\n  .right {\n    height: 100%;\n    width: 100%;\n  }\n}\n",".qingdan-zimu ::v-deep .el-tabs__nav {\n  background: #fff;\n}\n.qingdan-zimu .left,\n.qingdan-zimu .right {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
